import sanitizeHtml from 'sanitize-html'

export const highlightSubstring = (word: string, query: string | null) => {
  const check = new RegExp(query || '', 'ig')
  return sanitizeHtml(
    word?.replace(check, (matchedText) => `<strong>${matchedText}</strong>`),
    {
      allowedTags: ['strong'],
    }
  )
}
